import wretch from 'wretch';
import {validator} from "@kta20-core/models/validator-customized";
import '@kta20-core/utils/strings';
import { BaseModule, IModuleConfig } from '@kta20-core/interfaces/base-module';
import { IAppContext } from "@kta20-core/interfaces/i-app-context";
import {IEventDispatcher, NetworkService} from "@kta20-core/net/network-service";
import {INativeCtxAPI} from "@kta20-core/interfaces/i-native-ctx-api";
import {AppContextService} from "@kta20-core/services/app-context-service";
import {BridgeManager} from "@kta20-core/bridge-manager";
import {ICORE_BRIDGE} from "@kta20-core/interfaces/i-core-bridge";
import {CoreBridge} from "@kta20-core/bridges/core-bridge";
import {I18nw} from "@kta20-core/i18nweb";
import {MODULE_CLASS_NAME} from "@kta20-core/constants";


export class CoreModule extends BaseModule {

    static CLASS_NAME=MODULE_CLASS_NAME;

    static async factory(appContext: IAppContext, moduleConfig?: IModuleConfig): Promise<BaseModule> {
        console.info(appContext);
        console.info(moduleConfig);

        //makes appcontext available to the all module
        //components using this hosting service
        AppContextService.get(appContext);

        BridgeManager.get().addBridge(
            ICORE_BRIDGE,
            CoreBridge.factory(
                I18nw.get()
            )
        );

        const networkEventDispatcher:IEventDispatcher =
            appContext.ctxAPI.name==='INativeCtxAPI' ? (<INativeCtxAPI>appContext.ctxAPI).getWindow() : appContext.ctxAPI;

        NetworkService.get(navigator, networkEventDispatcher);

        return new CoreModule;
    };
}

export {EventTarget} from 'event-target-shim';
export {Guid} from 'guid-typescript';
export {validator};
export {wretch};
